import React, { useState, useEffect } from "react";
import "./pcb.css";
import Header from "../../components/Header/Header";
import HeaderServices from "../../components/Header/HeaderServices";
import Footer from "../../components/Footer/Footer";
import FooterServices from "../../components/Footer/FooterServices";
import { Select, MenuItem, Modal, Box, Button } from "@mui/material"; // Importar componentes de Material-UI
import { useUser } from "../../Context/UserContext";
import { addCRShippingCost, createPCBOrder, validateOrder } from "../../services/posOrders";
import { getOrderRef } from "../../services/getOrders";
import { subirArchivoAOrden } from "../../services/PCB/uploadFile";
import { updateThirdPartyPhone } from "../../services/Thirdparties/posThirdparties";

const PCB = () => {
  const [sizeOption, setSizeOption] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [customDesign, setCustomDesign] = useState(false);
  const [contactNumber, setContactNumber] = useState("");
  const [price, setPrice] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [pickupLocation, setPickupLocation] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const { user, setUser } = useUser();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar el modal

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setIsUserLoggedIn(true);
    } else {
      setIsUserLoggedIn(false);
    }
  }, [setUser]);

  useEffect(() => {
    updatePrice();
  }, [sizeOption, quantity, customDesign]);

  const handleSizeOptionChange = (size) => {
    setSizeOption(size);
  };

  const handleQuantityChange = (value) => {
    const qty = parseInt(value) || 1;
    setQuantity(qty > 0 ? qty : 1);
  };

  const toggleCustomDesign = () => {
    setCustomDesign(!customDesign);
    if (!customDesign && sizeOption === "") {
      setSizeOption("small");
    }
  };

  const updatePrice = () => {
    let basePrice = 0;

    if (sizeOption === "small") {
      basePrice = 5000;
    } else if (sizeOption === "large") {
      basePrice = 9000;
    }

    setPrice(basePrice * quantity);
  };

  const getCustomDesignPrice = () => {
    return customDesign ? 2500 : 0;
  };

  const getTotalPrice = () => {
    let total = price + (customDesign ? getCustomDesignPrice() : 0);
    if (pickupLocation === "222") {
      total += 2500; // Agregar costo adicional si se selecciona Correos de Costa Rica
    }
    return total;
  };

  const getSizeText = () => {
    if (customDesign) return "Se decidirá el día";
    if (sizeOption === "small") return "Pequeño (7.5x10cm)";
    if (sizeOption === "large") return "Grande (15x10cm)";
    return "-";
  };

  const handleFileUpload = (e) => {
    setUploadedFile(e.target.files[0]); // Guardar el archivo subido
  };

  const isPayButtonDisabled = () => {
    if (customDesign) {
      return !contactNumber; // Solo se valida el número de contacto
    } else {
      return !uploadedFile || !paymentMethod || !pickupLocation;
    }
  };

  const handlePayButtonClick = () => {
    if (!isPayButtonDisabled()) {
      setIsModalOpen(true); // Abrir el modal si todo está bien
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Cerrar el modal
  };

  const handleConfirmOrder = async () => {
    const productData = {
      fk_product: customDesign ? 315 : sizeOption === "small" ? 313 : 314,
      qty: customDesign ? 1 : quantity,
      subprice: customDesign ? 0 : price / quantity,
    };
    
    try {
      
      // Paso 1: Crear la orden
      const orderId = await createPCBOrder(
        parseInt(user.id),
        productData,
        parseInt(customDesign ? "5" : pickupLocation === "222" ? "5" : pickupLocation),
        parseInt(paymentMethod)
      );
      
      // Paso 2: Añadir costo de envío si aplica
      if (!customDesign && pickupLocation === "222") {
        await addCRShippingCost(orderId, {
          qty: "1",
          label: "+₡2500",
          subprice: "2500",
        });
      }
      
      // Paso 3: Subir el archivo si no es diseño personalizado
      if (!customDesign) {
        await validateOrder(orderId);
        let ref = await getOrderRef(orderId); // Obtener referencia de la orden
        let subir = await subirArchivoAOrden(uploadedFile, ref);
        console.log(ref, subir, uploadedFile.name);
      }
      
      // Paso 4: Actualizar el número de teléfono si es diseño personalizado
      if (customDesign && contactNumber) {
        await updateThirdPartyPhone(user.id, contactNumber);
        await validateOrder(orderId);
      }
      
      setIsModalOpen(false); // Cerrar el modal después de confirmar
      alert("Pedido confirmado con éxito.");
      
      // Recargar la página DESPUÉS de completar todas las operaciones
      window.location.reload();
      
    } catch (error) {
      // Manejo de errores
      console.error("Error durante el proceso de confirmación:", error);
      alert("Ocurrió un error al procesar el pedido. Por favor, inténtalo de nuevo.");
    }
  };

  if (!isUserLoggedIn) {
    return (
      <div className="pcb-page">
        <HeaderServices />
        <div className="pcb-hero">
          <div className="pcb-hero-content">
            <h1 className="pcb-hero-title">
              <span>Servicio de</span>
              <span className="gradient-text">Fabricación de PCB</span>
            </h1>
            <p className="pcb-hero-description">
              Para ingresar a nuestros servicios, necesitas estar conectado a una cuenta de Volteon.
            </p>
          </div>
        </div>
        <FooterServices />
      </div>
    );
  }

  const getMissingFieldsMessage = () => {
    if (customDesign) {
      if (!contactNumber) {
        return "Por favor, ingrese su número de teléfono.";
      }
    } else {
      if (!uploadedFile && !paymentMethod && !pickupLocation) {
        return "Por favor, suba un archivo Gerber, seleccione un método de pago y un punto de entrega.";
      }
      if (!uploadedFile) {
        return "Por favor, suba un archivo Gerber.";
      }
      if (!paymentMethod) {
        return "Por favor, seleccione un método de pago.";
      }
      if (!pickupLocation) {
        return "Por favor, seleccione un punto de entrega.";
      }
    }
    return ""; // No falta nada
  };

  return (
    <div className="pcb-page">
      <HeaderServices />
      <div className="pcb-hero">
        <div className="pcb-hero-content">
          <h1 className="pcb-hero-title">
            <span>Servicio de</span>
            <span className="gradient-text">Fabricación de PCB</span>
          </h1>
          <p className="pcb-hero-description">
            Sube tu archivo Gerber y configura tu pedido. Entrega garantizada en máximo <strong>5 días hábiles</strong>.
          </p>
        </div>
      </div>
      <div className="pcb-container">

        {/* COLUMNA 1 — Archivo del proyecto */}
        <div className="pcb-column">
          <h2>Archivo del Proyecto</h2>

          <label className={`pcb-file-dropzone${customDesign ? " disabled" : ""}${uploadedFile ? " has-file" : ""}`}>
            <input
              type="file"
              accept=".gbr,.zip"
              onChange={handleFileUpload}
              disabled={customDesign}
              style={{ display: "none" }}
            />
            <div className="pcb-file-icon">📁</div>
            {uploadedFile ? (
              <>
                <span className="pcb-file-name">{uploadedFile.name}</span>
                <span className="pcb-file-hint">Archivo listo</span>
              </>
            ) : (
              <>
                <span className="pcb-file-format">Formato ZIP</span>
                <span className="pcb-file-hint">Incluye archivos Gerber y proyecto</span>
              </>
            )}
            <span className="pcb-file-btn">
              {uploadedFile ? "✓ Cambiar Archivo" : "↑ Seleccionar Archivo"}
            </span>
          </label>

          <div className="contact-field">
            <label className="pcb-label">Número de Contacto</label>
            <input
              type="tel"
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
              placeholder="Teléfono"
              className="pcb-input"
            />
          </div>
        </div>

        {/* COLUMNA 2 — Requisitos técnicos */}
        <div className="pcb-column">
          <h2>Requisitos Técnicos</h2>
          <ul className="pcb-requirements">
            <li>Pistas de <strong>mínimo 0.8 mm</strong></li>
            <li>Una sola cara, <strong>through hole</strong></li>
            <li>Huecos preferiblemente de <strong>0.8, 1 y 1.2 mm</strong>. Medidas distintas consultar primero.</li>
            <li>El pad debe ser <strong>1 mm mayor</strong> que el diámetro del hueco, o usar <strong>pads ovalados</strong>.</li>
          </ul>
          <div className="pcb-requirements-footer">
            <p className="pcb-requirements-tip-title">¿No cumples los requisitos?</p>
            <p>Marca la opción "Diseñar de 0" y te ayudamos.</p>
          </div>
        </div>

        {/* COLUMNA 3 — Especificaciones del PCB */}
        <div className="pcb-column">
          <h2>Especificaciones del PCB</h2>
          <div className="pcb-spec-row">
            <span className="pcb-spec-label">Material Base</span>
            <span className="pcb-spec-value">Cobre Laminado</span>
          </div>
          <div className="pcb-spec-row">
            <span className="pcb-spec-label">Capas</span>
            <span className="pcb-spec-value">1</span>
          </div>

          {!customDesign && (
            <>
              <div className="pcb-spec-row">
                <span className="pcb-spec-label">Tamaño</span>
              </div>
              <div className="pcb-buttons">
                <button
                  className={sizeOption === "small" ? "active" : ""}
                  onClick={() => handleSizeOptionChange("small")}
                >
                  Pequeño<br/><small>7.5 × 10 cm</small>
                </button>
                <button
                  className={sizeOption === "large" ? "active" : ""}
                  onClick={() => handleSizeOptionChange("large")}
                >
                  Grande<br/><small>15 × 10 cm</small>
                </button>
              </div>

              <div className="pcb-spec-row" style={{ marginTop: "20px" }}>
                <span className="pcb-spec-label">Cantidad</span>
              </div>
              <div className="pcb-quantity-display">{quantity}</div>
              <input
                type="range"
                min="1"
                max="20"
                value={quantity}
                onChange={(e) => handleQuantityChange(e.target.value)}
                className="pcb-slider"
              />
            </>
          )}

          <div className="pcb-option checkbox-option">
            <label className="pcb-checkbox-label">
              <input
                type="checkbox"
                checked={customDesign}
                onChange={toggleCustomDesign}
                className="pcb-checkbox"
              />
              <span className="pcb-checkbox-custom"></span>
              Diseñar de 0 (₡2,500 / hora)
            </label>
          </div>
        </div>

        {/* COLUMNA 4 — Detalles del servicio */}
        <div className="pcb-column">
          <h2>Detalles del Servicio</h2>
          <div className="pcb-details-table">
            <div className="pcb-detail-row">
              <span className="pcb-detail-label">Material</span>
              <span className="pcb-detail-val">Cobre Laminado</span>
            </div>
            <div className="pcb-detail-row">
              <span className="pcb-detail-label">Capas</span>
              <span className="pcb-detail-val">1</span>
            </div>
            <div className="pcb-detail-row">
              <span className="pcb-detail-label">Tamaño</span>
              <span className="pcb-detail-val">{getSizeText()}</span>
            </div>
            <div className="pcb-detail-row">
              <span className="pcb-detail-label">Cantidad</span>
              <span className="pcb-detail-val">{quantity}</span>
            </div>
            {!customDesign ? (
              <div className="pcb-detail-row">
                <span className="pcb-detail-label">Precio PCBs</span>
                <span className="pcb-detail-val">₡{price.toFixed(0)}</span>
              </div>
            ) : (
              <div className="pcb-detail-row">
                <span className="pcb-detail-label">Diseño</span>
                <span className="pcb-detail-val">₡2,500/Hr</span>
              </div>
            )}
          </div>

          <div className="pcb-total-block">
            <span className="pcb-total-label">Total a Pagar</span>
            <span className="total-price">
              {!customDesign
                ? `₡${getTotalPrice().toFixed(0)}`
                : `₡2,500/Hr + PCB`}
            </span>
          </div>

          <Select
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            displayEmpty
            fullWidth
            className="pcb-select"
          >
            <MenuItem value="" disabled>Método de pago</MenuItem>
            <MenuItem value="106">Sinpe Móvil</MenuItem>
            <MenuItem value="4">Efectivo</MenuItem>
          </Select>

          {!customDesign && (
            <Select
              value={pickupLocation}
              onChange={(e) => setPickupLocation(e.target.value)}
              displayEmpty
              fullWidth
              className="pcb-select"
              style={{ marginTop: "10px" }}
            >
              <MenuItem value="" disabled>Punto de entrega</MenuItem>
              <MenuItem value="222">Correos de Costa Rica (Suma ₡2500)</MenuItem>
              <MenuItem value="1">Asocia Computadores</MenuItem>
              <MenuItem value="2">Asocia Mecatrónica</MenuItem>
              <MenuItem value="4">Asocia Electrónica (Cartago)</MenuItem>
              <MenuItem value="6">Asocia Electrónica (San Carlos)</MenuItem>
            </Select>
          )}

          <button
            className="pcb-pay-button"
            disabled={isPayButtonDisabled()}
            onClick={handlePayButtonClick}
          >
            Confirmar Pedido
          </button>

          <div className="missing-fields-message">
            {getMissingFieldsMessage()}
          </div>
        </div>

        {/* Modal */}
        <Modal open={isModalOpen} onClose={handleModalClose}>
          <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
                borderRadius: "8px",
                textAlign: "center", // Centrar todo el texto
                color: "black", // Cambiar el color de la fuente a negro
              }}
          >
            <h2>Detalles del Pedido</h2>
            {customDesign && (
                <p>Serás contactado por un agente en las próximas 48 horas.</p>
            )}
            {!customDesign && (
                <p>
                  El pedido se dejará en{" "}
                  {pickupLocation === "222"
                      ? "Correos de Costa Rica"
                      : pickupLocation === "1"
                          ? "la Asocia de estudiantes de Computadores"
                          : pickupLocation === "2"
                              ? "la Asocia de estudiantes de Mecatrónica"
                              : pickupLocation === "4"
                                  ? "la Asocia de estudiantes de Electrónica (Cartago)"
                                  : pickupLocation === "6"
                                      ? "la Asociación de estudiantes de Electrónica (San Carlos)"
                                      : "el lugar seleccionado"}
                  .
                </p>
            )}
            <p>
              El diseñador creará el diseño e imprimirá la placa y la terminará
              en un plazo de 5 días hábiles.
            </p>
            <h3>Detalles del pedido:</h3>
            <ul style={{textAlign: "left", paddingLeft: "20px"}}>
              <li>Tamaño: {getSizeText()}</li>
              {!customDesign && (<li>Cantidad: {quantity}</li>)}
              <li>Diseño personalizado: {customDesign ? "Sí" : "No"}</li>
              <li>
                Método de pago:{" "}
                {paymentMethod === "106"
                    ? "Sinpe Móvil"
                    : paymentMethod === "4"
                        ? "Efectivo"
                        : "No seleccionado"}
              </li>
              {!customDesign && (
                  <li>
                    Punto de entrega:{" "}
                    {pickupLocation === "222"
                        ? "Correos de Costa Rica"
                        : pickupLocation === "1"
                            ? "Asocia de estudiantes de Computadores"
                            : pickupLocation === "2"
                                ? "Asocia de estudiantes de Mecatrónica"
                                : pickupLocation === "4"
                                    ? "Asocia de estudiantes de Electrónica (Cartago)"
                                    : pickupLocation === "6"
                                        ? "Asociación de estudiantes de Electrónica (San Carlos)"
                                        : "No seleccionado"}
                  </li>
              )}
              {!customDesign && (<li>
                Archivo subido: {uploadedFile ? uploadedFile.name : "Ninguno"}
              </li>)}
              {!customDesign && (
                  <li>Precio total: ₡{getTotalPrice().toFixed(0)}</li>
              )}
            </ul>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <Button
                  variant="outlined"
                  onClick={handleModalClose}
                  style={{marginTop: "10px"}}
              >
                Cancelar
              </Button>
              <Button
                  variant="contained"
                  onClick={handleConfirmOrder}
                  style={{marginTop: "10px"}}
              >
                Confirmar
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
      <FooterServices/>
    </div>
  );
};

export default PCB;